export default __webpack_public_path__ + "static/media/MiniTape_SideB_05_Schützenfest2-2.de46dc37.mp3";